'use strict';

const KEY_ENTER = 13;
const KEY_ARROW_UP = 38;
const KEY_ARROW_DOWN = 40;
const TEMPLATES = {
  main: require('../main.html.mustache'),
};

module.exports = (function() {
  class FancyDropDown {
    static initClass() {
      this.prototype.onChangeCallbacks = [];
    }

    constructor({ el, options }) {
      this.keyDown = this.keyDown.bind(this);
      this.hideOptions = this.hideOptions.bind(this);
      this.$el = $(el);
      this.render(options);
      this.$dropDown = this.$el.find('.fancy-drop-down');
      this.$selected = this.$el.find('.fancy-drop-down-selected');
      this.$options = this.$el.find('.fancy-drop-down-option');
      this.$optionsWrapper = this.$el.find('.fancy-drop-down-options');
      this.bindings();
    }

    render(options) {
      for (const option of options) {
        if (option.isSelected === true) {
          this.selected = option;
          break;
        }
      }

      const radioName = `fancy-drop-down-${new Date().getTime()}`;
      return this.$el.html(
        TEMPLATES.main.render({
          radioName,
          options,
          selected: this.selected,
        })
      );
    }

    value() {
      return this.selected.value;
    }

    bindings() {
      this.$el.find('.fancy-drop-down-selected-and-arrow').click(() => {
        if (this.$dropDown.hasClass('open')) {
          return this.hideOptions();
        } else {
          return this.showOptions();
        }
      });
      return this.$options.click(evt => {
        // Avoid double click event when clicking a label.
        if (evt.target.nodeName === 'INPUT') {
          return null;
        }

        return this.chooseOption($(evt.currentTarget));
      });
    }

    chooseOption($option) {
      const $input = $option.find('input');
      const text = $input.data('text');
      const value = $input.val(); // Do not trigger a change event if the user selects the same option that is already selected.

      if (this.selected.value === value) {
        return null;
      }

      this.$options.removeClass('checked');
      $option.addClass('checked');
      this.$selected.text(text);
      this.selected = {
        text,
        value,
      };
      return this.onChangeCallbacks.map(cb => {
        cb({
          text,
          value,
        });
      });
    }

    onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }

    keyDown(evt) {
      switch (evt.which) {
        case KEY_ARROW_DOWN:
          this.moveSelectionDown();
          evt.preventDefault();
          break;

        case KEY_ARROW_UP:
          this.moveSelectionUp();
          evt.preventDefault();
          break;

        case KEY_ENTER:
          this.chooseSelected();
          evt.preventDefault();
          break;
      }
    }

    showOptions() {
      this.$dropDown.addClass('open');
      $(document).on('keydown', this.keyDown);
      return setTimeout(() => $(document).on('click', this.hideOptions), 1);
    }

    hideOptions() {
      this.$options.removeClass('selected');
      this.$dropDown.removeClass('open');
      $(document).off('keydown', this.keyDown);
      return $(document).off('click', this.hideOptions);
    }

    highlightSelectedOption(rowNumber) {
      if (this.$options[rowNumber] == null) {
        return null;
      }

      this.$options.removeClass('selected');
      const $selected = $(this.$options[rowNumber]);
      return $selected.addClass('selected');
    } // step should be a positive or negative number

    getNextHighlightedOptionNumber(step) {
      let selected;

      if (!(this.$options.length > 0)) {
        return null;
      }

      for (
        let i = 0, end = this.$options.length, asc = 0 <= end;
        asc ? i <= end : i >= end;
        asc ? i++ : i--
      ) {
        if ($(this.$options[i]).hasClass('selected')) {
          selected = i;
          break;
        }
      }

      if (selected == null) {
        if (step > 0) {
          selected = -1;
        } else {
          selected = 0;
        }
      }

      let number = (selected + step) % this.$options.length;

      if (number < 0) {
        number = this.$options.length + number;
      }

      return number;
    }

    moveSelectionDown() {
      const number = this.getNextHighlightedOptionNumber(1);
      return this.highlightSelectedOption(number);
    }

    moveSelectionUp() {
      const number = this.getNextHighlightedOptionNumber(-1);
      return this.highlightSelectedOption(number);
    }

    chooseSelected() {
      const $option = this.$optionsWrapper.find(
        '.fancy-drop-down-option.selected'
      );
      this.chooseOption($option);
      return this.hideOptions();
    }
  }
  FancyDropDown.initClass();
  return FancyDropDown;
})();
